import React from 'react'
import { connect } from 'react-redux'

import PageLoader from '../../../UI/PageLoader/PageLoader'
import AxiosLoader from '../../../UI/AxiosLoader/AxiosLoader'

const ReduxLoader = ({ config, score, lead }) => (
  <React.Fragment>
    {config.loading && <PageLoader />}
    {(score.loading || lead.loading) && <AxiosLoader />}
  </React.Fragment>
)

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {})(ReduxLoader)
